import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {CharCounter, CharCounterConfig} from "./char_counter"

export const charCounterLoader = function (options = {}) {
    componentLoader(componentConfig(CharCounter, CharCounterConfig.componentTypeKey, CharCounterConfig.baseHtmlClass), options);
};

